<template>
    <button @click="approve" class="btn btn-outline-success btn-sm pull-right mr-2">
        {{$t('measurement.BtnApprove')}}
    </button>
</template>

<script>
    export default {
        methods: {
            approve() {
                this.$swal({
                    title: this.$t('swal.approve.Title'),
                    text: this.$t('swal.approve.Text'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    cancelButtonText: this.$t('swal.approve.CancelButtonText'),
                    confirmButtonText: this.$t('swal.approve.ConfirmButtonText')
                }).then(async (result) => {
                        if (result.value) {
                            let ids = []
                            let checks = this.$parent.$refs['measurementsTable'].selectedRows

                            //ids in goed formaat zetten voor API
                            for (var key in checks) {
                                ids.push(checks[key].id)
                            }

                            let resp = await this.$store.dispatch('APPROVE_MEASUREMENTS', ids)
                            this.$parent.loadItems();

                            this.$swal({
                                title: this.$t('swal.logout.SuccessTitle'),
                                text: resp.data.message,
                                type: "success",
                                toast: true,
                                showConfirmButton: false,
                                position: 'top-end',
                                timer: 1200
                            });
                        }
                    }
                )
            }
        }
    }
</script>
